import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { DepositItemBody } from './DepositItem'
import { toFixedIfNull } from '../../../../helpers'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import { selectAccessToken } from '../../../../store/redusers/auth/selectors'
import { checkMarginCall, setMarginCallSent } from '../../../../store/redusers/positions/actions'
import {
	selectMarginCallSent,
	selectMarginRatio,
	selectTailDigitOfCurrency,
	selectTotalEquity,
	selectUsedMargin
} from '../../../../store/redusers/positions/selectors'
import { selectMarginCallRate, selectUserId } from '../../../../store/redusers/user/selectors'

function DepositItemMarginRatio({deposit}) {
	const { alert, dispatch, theme, mdDown} = useDefaultComponentTools()
	const totalEquity = useSelector(selectTotalEquity)
	const marginRatio = useSelector(selectMarginRatio)
	const accessToken = useSelector(selectAccessToken)
	const userId = useSelector(selectUserId)
	const marginCallRate = useSelector(selectMarginCallRate)
	const marginCallSentG = useSelector(selectMarginCallSent)
	const totalAmountTradeOpenPosition = useSelector(selectUsedMargin)
	const tailDigitOfCurrency = useSelector(selectTailDigitOfCurrency) || 2


	useEffect(() => {
		let marginCallSent = marginCallSentG
		let nowTimeInSeconds = Math.floor(Date.now() / 1000)
		if(marginCallSent > nowTimeInSeconds - 5) return
		dispatch(setMarginCallSent(nowTimeInSeconds))
		let marginCall = 0
		let userMarginCall = marginCallRate ? marginCallRate : 0
		if(localStorage.getItem('newUserData') != null) {
			let newUserData = JSON.parse(localStorage.getItem('newUserData'))
			userMarginCall = newUserData.marginCallRate
		}
		try {
			if(totalAmountTradeOpenPosition > 0){
				marginCall = totalEquity.div(totalAmountTradeOpenPosition)
				if(!isNaN(parseFloat(marginCall)) && marginCall.greaterThanOrEqualTo(userMarginCall) == false )	{
					if (accessToken) {
						dispatch(checkMarginCall(accessToken, userId, alert))
					}
				}
			}
		} catch (e) {
			// eslint-disable-next-line
			console.log(e)
		}
	}, [totalEquity])


	return (
		<DepositItemBody>
			<Typography
				sx={{color: theme.palette.text.secondary, fontWeight: 400, mr: mdDown ? '10px' : 0}}>
				{deposit.label}
			</Typography>
			<Box sx={{display: 'flex'}}>
				<Typography variant='px13'>
					{toFixedIfNull(marginRatio, tailDigitOfCurrency) || 0}
				</Typography>
				<Typography variant='px13' sx={{ml: 0.5}}>%</Typography>
			</Box>
		</DepositItemBody>
	)
}

DepositItemMarginRatio.propTypes = {
	deposit: PropTypes.object
}

export default DepositItemMarginRatio
